module.exports = "/assets/e761870b4416cf42c9367718c4be5b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UD.png
// module id = 1887
// module chunks = 0